// extracted by mini-css-extract-plugin
export default {"viewPhoneNumberButton":"_5pJLMmJkZ0z75DvOXxPszY"};